import React from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from './Logo'
import { TOOLS } from '../data/tools'

const COLS = [
  { h: 'Image Editing', ids: ['compress', 'resize', 'crop', 'convert', 'removebg'] },
  { h: 'Enhance & Utility', ids: ['blurface', 'rotate', 'upscale', 'watermark', 'img2pdf'] },
  { h: 'PDF Management', ids: ['merge', 'split', 'compresspdf', 'editpdf', 'sign', 'protect', 'unlock', 'rotatepdf', 'pagenum'] },
  { h: 'PDF Conversion', ids: ['pdf2word', 'word2pdf', 'pdf2ppt', 'ppt2pdf', 'pdf2excel', 'excel2pdf', 'pdf2jpg', 'wmpdf'] },
]

function Footer() {
  const navigate = useNavigate()
  const tool = (id) => navigate('/tool/' + id)
  const page = (p) => navigate(p)

  return (
    <footer>
      <div className="wrap">
       

        <div className="foot-cols">
           <div className="foot-brand">
          <Logo />
          <p>Fast, secure, and easy to use Image and PDF tools for all your file conversion and editing needs.</p>
        </div>
          {COLS.map((col) => (
            <div className="foot-col" key={col.h}>
              <h5>{col.h}</h5>
              {col.ids.map((id) => (
                <a key={id} onClick={() => tool(id)}>{TOOLS[id].name}</a>
              ))}
            </div>
          ))}
        </div>

        <div className="foot-bottom">
          <span>© 2026 iloveimgpdf. Made for getting things done.</span>
          <div className="foot-links-inline">
            <a onClick={() => page('/about')}>About</a>
            <a onClick={() => page('/privacy')}>Privacy Policy</a>
            <a onClick={() => page('/contact')}>Contact</a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
